module.exports = __webpack_public_path__ + "img/08848231001052.712361d0.png";